import React from "react";
import { Briefcase, Building, User, Globe } from "lucide-react";
import Link from "next/link";

const options = [
  {
    icon: <Briefcase className="w-8 h-8 text-amber-500" />,
    title: "Personal Training Agencies",
    description: (
      <>
        Agencies like{" "}
        <a
          href="https://fitfamco.com"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="text-amber-600 underline hover:text-amber-700"
        >
          fitfamco
        </a>
        ,{" "}
        <a
          href="https://pts.sg"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="text-amber-600 underline hover:text-amber-700"
        >
          PTS.sg
        </a>
        , and{" "}
        <a
          href="https://msfit.sg"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="text-amber-600 underline hover:text-amber-700"
        >
          MSFIT
        </a>{" "}
        match clients with trainers based on fitness goals and preferences.
      </>
    ),
  },
  {
    icon: <Building className="w-8 h-8 text-amber-500" />,
    title: "Fitness Studios",
    description: (
      <>
        Well-known studios such as{" "}
        <a
          href="https://level.com.sg/"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="text-amber-600 underline hover:text-amber-700"
        >
          LEVEL Singapore
        </a>{" "}
        and{" "}
        <a
          href="https://purefitness.com"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="text-amber-600 underline hover:text-amber-700"
        >
          PURE Fitness
        </a>{" "}
        offer personal training within their facilities.
      </>
    ),
  },
  {
    icon: <User className="w-8 h-8 text-amber-500" />,
    title: "Independent Trainers",
    description:
      "Many trainers operate independently, marketing themselves via their own websites, Instagram, or through gym partnerships.",
  },
  {
    icon: <Globe className="w-8 h-8 text-amber-500" />,
    title: "Online Marketplaces",
    description: (
      <>
        Platforms like{" "}
        <a
          href="https://stringssg.com"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="text-amber-600 underline hover:text-amber-700"
        >
          StringsSG
        </a>{" "}
        allow you to search for nearby trainers, while{" "}
        <a
          href="https://myfitnesscomrade.com"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="text-amber-600 underline hover:text-amber-700"
        >
          My Fitness Comrade
        </a>{" "}
        provides budget-friendly options.
      </>
    ),
  },
];

export default function ExploreOptions() {
  return (
    <section
      className="max-w-5xl mx-auto py-10 px-4"
      aria-labelledby="explore-options"
    >
      <header className="text-center mb-10">
        <h2
          id="explore-options"
          className="text-2xl md:text-3xl font-bold text-gray-900"
        >
          2. Explore Different Options
        </h2>
        <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
          There are several avenues to find a personal trainer in Singapore:
        </p>
      </header>

      <div className="grid md:grid-cols-2 gap-10">
        {options.map(({ icon, title, description }, idx) => (
          <article
            key={idx}
            className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow border border-gray-100"
          >
            <div className="flex items-center gap-4 mb-4">{icon}
                <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
            </div>
            <p className="text-gray-700 leading-relaxed">{description}</p>
          </article>
        ))}
      </div>
      <div className='bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow border border-gray-100 space-y-10 mt-10 text-center'>
          <p>
              Explore 200+ personal training packages and deals, including free and discounted trials starting from just $20.
          </p> 
          <div>
              <Link href="/sg/personal-trainer/deals" prefetch={false} 
              className='text-orange-600 p-3 border border-orange-600 rounded-2xl hover:text-orange-500 hover:shadow-lg'>
                  Deals & Packages
              </Link>
          </div>
      </div>
    </section>
  );
}